export default "__VITE_ASSET__zZg6MsnI__"